export default __webpack_public_path__ + "static/media/scim-bridge.6c088b18.svg";